// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';

// Models
import { AppCleanup } from '../models';

@Injectable()
export class HttpUtilsService extends AppCleanup implements OnInit, OnDestroy {
	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
	/**
	 * Prepare query http params
	 * @param queryParams: QueryParamsModel
	 */
	getFindHTTPParams(queryParams): HttpParams {
		const params = new HttpParams()
			.set('lastNamefilter', queryParams.filter)
			.set('sortOrder', queryParams.sortOrder)
			.set('sortField', queryParams.sortField)
			.set('pageNumber', String(queryParams.pageNumber))
			.set('pageSize', String(queryParams.pageSize));

		return params;
	}

	/**
	 * get standard content-type
	 */
	getHTTPHeaders(): HttpHeaders {
		const result = new HttpHeaders();
		result.set('Content-Type', 'application/json');
		return result;
	}
}
